import { BASE_URL } from '../API/BASE_URL';

export const getExperts = async () => {
  const response = await fetch(BASE_URL + 'experts/experts/', {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
